import { Pipe, PipeTransform } from '@angular/core';
import { Language } from 'app/language/store/language.interfaces';

@Pipe({
  standalone: true,
  name: 'translateLanguage',
})
export class TranslateLanguage implements PipeTransform {
  public transform(value: Language | null): string {
    if (!value) {
      return '-';
    }

    switch (value) {
      case 'en':
        return `LANGUAGE.ENGLISH`;
      case 'es':
        return `LANGUAGE.SPANISH`;
      case 'pt':
        return `LANGUAGE.PORTUGUESE`;
      default:
        return '-';
    }
  }
}
